export default [{
    path: '/apartments/:id',
    name: 'apartment-view',
    component: () => import('@/views/modules/MyObjects/Apartments/view.vue'),
    meta: {
      unique_name: "",
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'navbars.object_accounting',
          active: false,
          to: '/my-objects',
        },
        {
          text: 'navbars.obj',
          active: false,
          to: '/my-objects/object/:id',
        },
        {
          text: 'navbars.home',
          active: true,
        },
      ],
      action: 'read',
      resource: 'sales',
    },
  },
  {
    path: '/apartments/:id/layout-details',
    name: 'apartment-detail-layout',
    component: () => import('@/views/modules/MyObjects/Apartments/checkerboardLayoutDetails.vue'),
    meta: {
      unique_name: "",
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'navbars.object_accounting',
          active: false,
          to: '/my-objects',
        },
        {
          text: 'navbars.obj',
          active: false,
          to: '/my-objects/object/:id',
        },
        {
          text: 'navbars.home',
          active: false,
          to: '/apartments/:id',
        },
        {
          text: 'objects.mash',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apartments/:id/block-view',
    name: 'apartment-block-view',
    component: () => import('@/views/modules/MyObjects/Apartments/blockView.vue'),
    props: true,
    meta: {
      unique_name: "",
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'navbars.object_accounting',
          active: false,
          to: '/my-objects',
        },
        {
          text: 'navbars.obj',
          active: false,
          to: '/my-objects/object/:id',
        },
        {
          text: 'navbars.home',
          active: false,
          to: '/apartments/:id',
        },
        {
          text: 'navbars.detaling_the_mash',
          active: true,
        },
      ],
      action: 'read',
      resource: 'sales',
    },
  },
  {
    path: '/apartments/:id/plannings',
    name: 'apartment-plannings-view',
    component: () => import('@/views/modules/MyObjects/Apartments/flatPlannings.vue'),
    meta: {
      unique_name: "",
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'navbars.object_accounting',
          active: false,
          to: '/my-objects',
        },
        {
          text: 'navbars.obj',
          active: false,
          to: '/my-objects/object/:id',
        },
        {
          text: 'navbars.home',
          active: false,
          to: '/apartments/:id',
        },
        {
          text: 'objects.layout_of_premises',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apartments/:id/stage-plannings',
    name: 'apartment-stage-plannings',
    component: () => import('@/views/modules/MyObjects/Apartments/stagePlannings.vue'),
    meta: {
      unique_name: "",
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'navbars.object_accounting',
          active: false,
          to: '/my-objects',
        },
        {
          text: 'navbars.obj',
          active: false,
          to: '/my-objects/object/:id',
        },
        {
          text: 'navbars.home',
          active: false,
          to: '/apartments/:id',
        },
        {
          text: 'navbars.floor_layouts',
          active: true,
        },
      ],
    },
  },
]